import React from "react";

export default function LawyerList({ children }) {
  return <div className="col-md-12 col-lg-8">{children}</div>;
}
